@if (loading) {
  <div class="loader"></div>
}
@if (!loading) {
  <div class="left-modal">
    <div class="close" (click)="close()"></div>
    @if (!loading) {
      <div class="modal-container">
        @if (phase) {
          <h1>{{'Edit phase' | translate}}</h1>
        }
        <p class="title-phase">{{_gS.backTranslate(phase,'phase')}}</p>
        <form #form="ngForm" (ngSubmit)="submitForm()" novalidate>
          <div class="row">
            <div class="L-12 M-12 S-12 columns">
              <div class="L-6 M-6 S-6 columns">
                <label>{{'Date start' | translate}}</label>
                <input type="date" name="date_start" [(ngModel)]="formData.date_start" required>
              </div>
              <div class="L-6 M-6 S-6 columns">
                <label>{{'Weeks' | translate}}</label>
                <input class="centered" numeric type="text" name="week" [(ngModel)]="formData.week" placeholder="{{'Insert' | translate}}" required>
              </div>
            </div>
          </div>
          <div class="L-12 M-12 S-12 columns TextCentered">
            <input name="sumbit" type="submit" value="{{'Save' | translate}}" [disabled]="form.invalid">
          </div>
          <div class="L-12 M-12 S-12 columns TextCentered">
            <a class="button cancel" (click)="close()">{{'Cancel' | translate}}</a>
          </div>
        </form>
      </div>
    }
  </div>
}